<!-- declared up here so the form's (ngSubmit) can be guarded too: Enter in the date field submits the form -->
@let isSubmitting = isSubmitting$ | async;
<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>{{ data.isWarning ? sysText.overrideWarningDate_title : sysText.overrideDueDate_title }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="!isSubmitting && onSubmit()">
    <app-date-field
      [control]="this.form.controls.date"
      [icon]="'today'"
      [label]="sysText.override_date">
    </app-date-field>
    <app-text-area
      [control]="this.form.controls.comments"
      [label]="sysText.override_comment"
      [icon]="'comment'">
    </app-text-area>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="space-between">
  @let isMobile = isMobile$ | async;
  <!-- restore and save share isSubmitting$, so submittingAction says which one was pressed: that one shows the spinner (showProgress)
  and the "loading" label. both stay focusable while busy (disabledInteractive), and the guards block clicks. on mobile, restore
  shows only its icon, so its label names it there -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting && submittingAction === 'restore'"
    [attr.aria-label]="isSubmitting && submittingAction === 'restore' ? sysText.submitting_ariaLabel : (isMobile ? (sysText.restoreDefault | capitalizefirst) : null)"
    [matTooltip]="isMobile ? (sysText.restoreDefault | capitalizefirst) : null"
    [matTooltipShowDelay]="500"
    matTooltipPosition="above"
    (click)="!isSubmitting && onSubmit(true)">
    <mat-icon class="button-icon restore-defaults-icon">settings_backup_restore</mat-icon>
    @if (!isMobile) {
      <span>
        {{ sysText.restoreDefault }}
      </span>
    }
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
  <div class="sub-container">
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        color="accent"
        [disabled]="isSubmitting"
        (click)="close(false)">
        {{ sysText.cancel }}
      </button>
    }
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting && submittingAction === 'save'"
      [attr.aria-label]="isSubmitting && submittingAction === 'save' ? sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && onSubmit()">
      {{ sysText.save }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </div>
</mat-dialog-actions>

